import styled from "styled-components";

interface IProps {
    text?: string;
}

export const TitlePage = (props: IProps) => {
    return (
        <StyledTitlePage>
            <span className="title-text">{props.text || "title"}</span>
        </StyledTitlePage>
    );
};

const StyledTitlePage = styled.div`
    display: block;
    text-align: center;
    /* margin-bottom: 30px; */
    .title-text {
        font-size: 32px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        position: relative;
        text-transform: uppercase;
        display: inline-block;
    }
`;
